import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import { User } from '../shared/client/entities';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'client';
  private loggedUser: User;

  constructor(
    private authService: AuthService
  ) {
  }

  async ngOnInit() {
    this.authService.currentUser$.subscribe((user) => {
      this.loggedUser = new User(user);
    });
  }

  public logout() {
    this.authService.logout();
  }
}
